import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import Loader from '../../layouts/loader';
import apiService from '../../../services/apiService';
import CustomToast from "../../Toast";

const CaseStudie = () => {
    const [caseStudies, setCaseStudie] = useState([]);
    const [caseStudiesTag, setCaseStudieTag] = useState([]);
    const [caseStudiesYear, setCaseStudieYear] = useState([]);
    const [loader, setLoader] = useState(false);
    const [filters, setFilters] = useState({ tag: '', year: '' });
    //  const [filters, setFilters] = useState({ tag: "" });
    const [filteredStudies, setFilteredStudies] = useState(caseStudies);

    const navigate = useNavigate();

    const showErrorToast = () => {
        CustomToast.info('It seems your connection is slow. Please refresh the page or try again in sometime.');
    };

    const fetchData = async (endpoint, token) => {
        try {
            return await apiService.get(endpoint, token);
        } catch (error) {
            console.error(error);
            showErrorToast();
        }
    };

    const getInitialData = async () => {
        setLoader(true);
        const token = apiService.getAuthToken();
        try {
            const [caseList, years, tags] = await Promise.all([
                fetchData('get-case-studies-list', token),
                fetchData('get-case-studies-year', token),
                fetchData('get-case-studies-tag', token)
            ]);
            setCaseStudie(caseList?.data || []);
            setCaseStudieYear(years?.data || []);
            setCaseStudieTag(tags?.data || []);
        } catch (err) {
            CustomToast.error('Failed to fetch case study data');
        } finally {
            setLoader(false);
        }
    };

    const fetchFilteredData = async (updatedFilters) => {
        const token = apiService.getAuthToken();
        const query = new URLSearchParams(updatedFilters).toString();
        setLoader(true);
        try {
            const data = await fetchData(`get-case-studies-list?${query}`, token);
            setCaseStudie(data?.data || []);
        } catch (error) {
            CustomToast.error('Failed to filter case studies');
        } finally {
            setLoader(false);
        }
    };

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        const updatedFilters = { ...filters, [name]: value };
        setFilters(updatedFilters);
        fetchFilteredData(updatedFilters);
    };

    //     const handleFilterChange = (e) => {
    //     const { name, value } = e.target;
    //     const updatedFilters = { ...filters, [name]: value };
    //     setFilters(updatedFilters);

    //     // Optional: immediately filter here or use useEffect
    //     filterCaseStudies(updatedFilters);
    // };

    // const filterCaseStudies = (filters) => {
    //     const filtered = caseStudies.filter(cs =>
    //         filters.tag ? cs.tags.includes(filters.tag) : true
    //     );
    //     setFilteredStudies(filtered);
    // };

    useEffect(() => {
        requestAnimationFrame(() => {
            window.scrollTo(0, 0);
        });
        getInitialData();
    }, []);

    return (
        <>
            {loader ? <Loader /> :
                <div className="page__main">
                    <div className="dashboard" style={{ minHeight: '100vh' }}>
                        <div className='container-fluid'>
                            <div className='row mb-4'>
                                <div className='col-7'>
                                    <h3 className="fw-semibold font-26 mb-2">Case Studies</h3>
                                    <span><small>Learnings from landmark judgements and case studies that have been instrumental in shaping the interpretation and implementation of the POSH Act in India.</small></span>
                                </div>
                                <div className='col-5'>
                                    <div className='d-flex gap-3' >
                                        <div className="col-7 position-relative">
                                            <select
                                                className={`form-select pe-5 ${filters.tag ? 'no-arrow' : ''}`}
                                                name="tag"
                                                value={filters.tag}
                                                onChange={handleFilterChange}
                                            >
                                                <option value="" disabled>Select theme</option>
                                                {caseStudiesTag.map((tag, index) => (
                                                    <option key={index} value={tag}>{tag}</option>
                                                ))}
                                            </select>

                                            {filters.tag && (
                                                <button
                                                    type="button"
                                                    onClick={() => {
                                                        const updatedFilters = { ...filters, tag: '' };
                                                        setFilters(updatedFilters);
                                                        fetchFilteredData(updatedFilters);
                                                    }}
                                                    className='clear-tag-button '

                                                >
                                                    <img
                                                        src="/images/cross-icon.svg"
                                                        alt="clear"
                                                    />
                                                </button>
                                            )}
                                        </div>

                                        <div className='col-5 position-relative'>
                                            <select
                                                className={`form-select pe-5 ${filters.year ? 'no-arrow' : ''}`}
                                                name="year"
                                                value={filters.year}
                                                onChange={handleFilterChange}
                                            // style={{ marginLeft: '10px' }}
                                            >
                                                <option value="" disabled>Year</option>
                                                {caseStudiesYear.map((tag, index) => (
                                                    <option key={index} value={tag}>{tag}</option>
                                                ))}
                                            </select>
                                            {filters.year && (
                                                <button
                                                    type="button"
                                                    onClick={() => {
                                                        const updatedFilters = { ...filters, year: '' };
                                                        setFilters(updatedFilters);
                                                        fetchFilteredData(updatedFilters);
                                                    }}
                                                    className='clear-tag-button'

                                                >
                                                    <img
                                                        src="/images/cross-icon.svg"
                                                        alt="clear"
                                                    />
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="row d-flex flex-wrap">
                                    {caseStudies?.length > 0 ? (
                                        caseStudies.map((study, index) => (
                                            <div key={index} className="col-md-4 mb-4 d-flex">
                                                <Link to={`/case-study/${study._id}`} className="text-decoration-none text-dark w-100">
                                                    <div className="card shadow-sm p-3 d-flex flex-column justify-content-between" style={{ background: "white", borderRadius: '10px', height: '100%' }}>
                                                        <div>
                                                            <div className="d-flex align-items-center mb-4">
                                                                <img
                                                                    src="/images/calendar_month.svg"
                                                                    alt="calendar icon"
                                                                    style={{ width: "20px", height: "18px", marginRight: "6px" }}
                                                                />
                                                                <span className="text-muted">{study.year}</span>
                                                            </div>
                                                            <h6 className="font-20 fw-bold mb-4">{study.title}</h6>
                                                            <p className="text-muted small mb-4 clamp-4-lines">{study.subtitle}</p>
                                                        </div>

                                                        <div className="mt-2">
                                                            {study?.tags?.map((tag, tagIndex) => (
                                                                <span key={tagIndex} className={`case-tag mb-2 me-2 ${getBadgeClass(tag)}`}>
                                                                    {tag}
                                                                </span>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </Link>
                                            </div>
                                        ))
                                    ) : (
                                        <div className="col-12 text-left">
                                            <p className="text-muted">No case studies found.</p>
                                        </div>
                                    )}

                                </div>
                            </div>
                        </div>
                    </div>
                </div>}
        </>
    );
};

const getBadgeClass = (tag) => {
    switch (tag) {
        case 'Employer Responsibility':
            return 'employer';
        case 'IC Constitution':
            return 'ic';
        case 'Govt Organisation':
            return 'govt';
        default:
            return 'bg-light text-dark';
    }
};

export default CaseStudie;